export const nominalFormat = (nominal: string | number | undefined) => {
  return new Intl.NumberFormat("id").format(+(+nominal! || 0).toFixed(2));
};